export const GET_DOG__BYID = 'GET_DOG__BYID';
export const GET_DOG__BYNAME = 'GET_DOG__BYNAME';
export const GET_DOG__BYTEMPERAMENT = 'GET_DOG__BYTEMPERAMENT';
export const GET_DOGS = 'GET_DOGS';
export const GET_TEMPERAMENTS = 'GET_TEMPERAMENTS';
export const REMOVE_SELECTED_DOG = 'REMOVE_SELECTED_DOG';
export const IS_LOADING = 'IS_LOADING';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const CHANGE_ORDER = 'CHANGE_ORDER';
// export const ADD_DOG = 'ADD_DOG';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CHANGE_SOURCE = 'CHANGE_SOURCE';
export const ADD_DOG_NAME = 'ADD_DOG_NAME';





